import Link from 'components/Link';
import Typography from 'components/Typography';
import { useEventContext } from 'context/EventContext';

import classes from './ManageProductListing.module.scss';

const ManageProductListing = ({
  productName,
  g2ProductSlug,
  engagementComponent,
}) => {
  const { addEvent } = useEventContext();

  if (!g2ProductSlug) {
    return null;
  }

  return (
    <div className={classes.wrapper}>
      <Typography
        component="p"
        variant="body-sm"
        data-testid="manage-product-listing"
      >
        Do you work for {productName}?{' '}
        <Link
          href={`https://www.g2.com/products/${g2ProductSlug}/claim_requests/new?auto=true`}
          target="_blank"
          className={classes.link}
          {...addEvent({
            name: 'engagement_facet_click',
            engagementComponent,
            engagementDestination: 'open_claim-profile-modal',
            engagementDetails: 'text-link_claim-profile',
          })}
        >
          Manage this product listing
        </Link>
      </Typography>
    </div>
  );
};

export default ManageProductListing;
